import * as React from 'react';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import { Translate } from '../../shared/LanguageService';
import DroneBookingsWarningContent from './DroneBookingsWarningContent';
import IUpcomingDroneBooking from './IUpcomingDroneBooking';

interface IDroneBookingsWarningModalProps {
    bookings: IUpcomingDroneBooking[];
    linkToOrders?: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const DroneBookingsWarningModal = (props: IDroneBookingsWarningModalProps) => (
    <ConfirmationModal
        title={Translate('photographers/drone/upcoming-bookings/confirmation/title')}
        text={
            <DroneBookingsWarningContent
                bookings={props.bookings}
                linkToOrders={props.linkToOrders}
            />
        }
        doButtonLabel={Translate('photographers/drone/upcoming-bookings/confirmation/do-button')}
        cancelButtonLabel={Translate(
            'photographers/drone/upcoming-bookings/confirmation/cancel-button'
        )}
        doButtonStyle="danger"
        do={props.onConfirm}
        closeModal={props.onClose}
    />
);

export default DroneBookingsWarningModal;
